{
  "create_new_schedule": "Crear un nuevo horario",
  "copy_schedule_alert": "La copia de los datos del cronograma puede tardar unos minutos",
  "manage_schedule_settings": "Gestione la configuración de la programación",
  "all_venues": "Todos los lugares",
  "no_venues": "No hay sedes",
  "x_venues_selected": "{{ count }} sedes seleccionadas",
  "view_by": "Ver por",
  "day": "Día",
  "venue": "Lugar",
  "cluster": "Clúster",
  "no_space_defined": "No hay espacio definido",
  "no_sessions_in_view": "No hay sesiones en esta vista",
  "discipline": "La disciplina",
  "day_discipline": "Día (Disciplina)",
  "day_venue": "Día (lugar)",
  "daily_run_sheet": "Hoja de ejecución diaria",
  "venue_run_sheet": "Hoja de carreras del lugar",
  "DCAS": "DCAS",
  "summary": "Resumen",
  "show_scheduled_items": "Mostrar elementos programados",
  "hide_scheduled_items": "Ocultar los elementos programados",
  "show_sessions": "Mostrar sesiones",
  "hide_sessions": "Ocultar sesiones",
  "error_loading_schedule": "Se ha producido un error al cargar la programación",
  "schedule": "Programar",
  "save_schedule": "guardar horario",
  "delete_schedule": "eliminar horario",
  "create_schedule_form": {
    "create_new_schedule": "Crea un nuevo horario",
    "name_field_label": "Nombre del nuevo horario",
    "status_field_label": "Establece el estado del nuevo horario",
    "status_field_options": {
      "draft_label": "Borrador",
      "draft_description": "La programación solo está visible para las personas nombradas en la configuración de permisos",
      "published_label": "Publicado",
      "published_description": "Visible para todos"
    },
    "copy_versions_label": "Selecciona los cronogramas disciplinarios que te gustaría copiar en este nuevo cronograma"
  },
  "create_sub_schedule_form": {
    "create_new_sub_schedule": "Crea un nuevo horario de {{ subSchedule }}",
    "parent_schedule": "Horario para padres",
    "new": "Nuevo",
    "copy_existing": "Copia de la existente",
    "name_of_calendar": "Nombre del calendario",
    "selectSubSchedulesToCopy": "Selecciona los {{ scheduleVersionType }} (s) que deseas copiar"
  },
  "edit_schedule_form": {
    "edit_schedule": "Gestiona la configuración de la programación",
    "name_field_label": "Nombre del cronograma",
    "status_field_label": "Establecer el estado del cronograma"
  },
  "edit_schedule_data_options": {
    "title": "Editar las opciones de datos del cronograma"
  },
  "add_data_fields_form": {
    "add_datafield_list_items": "Agregar elementos a la lista de atributos",
    "download_template": "Descargar la plantilla CSV",
    "upload": "Cargar CSV",
    "venue_location": "Ubicación del lugar"
  },
  "settings": "ajustes",
  "visibility": "visibilidad",
  "create_session_form": {
    "create_new_session": "Crear nueva sesión",
    "ticketedDescription": "La sesión está marcada como con tickets de forma predeterminada",
    "headings": {
      "formTitleNew": "Nueva sesión",
      "formTitleEdit": "Editar sesión",
      "details": "Detalles",
      "time": "Horarios de sesión",
      "venue": "Lugar",
      "events": "Eventos de esta sesión",
      "type": "Estilo de sesión",
      "entry": "Entrada y transmisión",
      "ticketingAndBroadcasting": "Venta de entradas y retransmisión",
      "ticketed": "Con boletos"
    },
    "inputLabels": {
      "code": "Código de sesión",
      "style": "Estilo de sesión",
      "description": "Descripción de la sesión (opcional)",
      "day": "Día",
      "spare": "Úselo como día libre",
      "sTime": "Hora de inicio",
      "eTime": "Hora de finalización",
      "zTime": "Hora cero",
      "zeroCheckBoxLabel": "Igual que la hora de inicio de la sesión",
      "estimated": "Finalización estimada",
      "duration": "Duración (minutos)",
      "ticketed": "Sesión con entrada"
    },
    "buttons": {
      "addEvent": "Añadir un evento",
      "addAnother": "Agregar otro evento",
      "removeEvent": "Eliminar evento",
      "addPhase": "Agregar fase",
      "addAnotherPhase": "Agregar otra fase",
      "cancel": "Cancelar",
      "save": "Guardar",
      "delete_session": "Eliminar sesión"
    },
    "delete": {
      "title": "Eliminar sesión",
      "message": "Al eliminar esta sesión, también se eliminarán los elementos programados y cualquier actividad que esté específicamente relacionada con ella. ¿Desea continuar?",
      "confirm": "Confirme",
      "cancel": "Cancelar"
    }
  },
  "summary_grid": {
    "venue": "Lugar",
    "discipline": "La disciplina"
  },
  "scheduled_item": {
    "CREATE": "Nuevo elemento programado",
    "EDIT": "Editar elemento programado",
    "within_event": "Dentro del evento",
    "delete_item": "Eliminar elemento",
    "venue": "Lugar",
    "space": "Espacio",
    "time": "Tiempo",
    "location": "Ubicación",
    "delete": {
      "title": "Eliminar elemento programado",
      "message": "¿Estás seguro?",
      "confirm": "Confirma",
      "cancel": "Cancelar"
    },
    "time_type": {
      "not_before": {
        "name": "No antes",
        "description": "El artículo programado no comenzará antes de la hora de inicio indicada."
      },
      "followed_by": {
        "name": "Seguido de",
        "description": "La hora de inicio depende de la hora de finalización del artículo programada anterior."
      }
    },
    "estimated_duration": "Duración estimada",
    "estimated_duration_description": "La duración exacta del artículo programado no es segura.",
    "save_and_next": "Guardar y continuar",
    "save_and_finish": "Guardar y terminar"
  },
  "session_card": {
    "day": "Día",
    "start_time": "Hora de inicio",
    "end_time": "Hora de finalización",
    "duration": "Duración",
    "medal_session": "Sesión de medallas",
    "add_scheduled_item": "Agregar elemento programado",
    "scheduled_items_in_session": "Elementos programados en la sesión",
    "events_in_session": "Eventos de la sesión",
    "close_popup": "Cerrar ventana emergente",
    "edit": "Editar",
    "zero_time": "Tiempo cero",
    "no_space": "Sin espacio",
    "in": "En",
    "show_more": "Mostrar más",
    "show_less": "Mostrar menos"
  }
}